import { useBlocker } from "@tanstack/react-router";
import { useBrowserNavigationProtection } from "@/hooks/useBrowserNavigationProtection";
import { UnsavedChangesConfirmDialog } from "./UnsavedChangesConfirmDialog";

interface UnsavedChangesDialogProps {
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isDirty: boolean;
  disabled?: boolean;
}

export function UnsavedChangesDialog({
  title = "Unsaved Changes",
  description = "Your changes will be lost if you leave without publishing. Are you sure you want to leave?",
  confirmLabel = "Leave anyway",
  cancelLabel = "Stay",
  isDirty,
  disabled = false,
}: UnsavedChangesDialogProps) {
  useBrowserNavigationProtection(isDirty);

  const blocker = useBlocker({
    shouldBlockFn: () => isDirty && !disabled,
    withResolver: true,
  });

  return (
    <UnsavedChangesConfirmDialog
      open={blocker.status === 'blocked'}
      onOpenChange={() => {}}
      onConfirm={() => blocker.proceed?.()}
      onCancel={() => blocker.reset?.()}
      title={title}
      description={description}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
    />
  );
}
